import { createTheme } from "@material-ui/core/styles";
import "./index.css";

const defaultTheme = createTheme();

const theme = createTheme({
  palette: {
    primary: {
      main: "#329AEC",
    },
    secondary: {
      main: "#00E5FF",
    },
    text: {
      primary: "#252551",
    },
  },
  typography: {
    fontFamily:
      "ui-sans-serif, system-ui, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji, Montserrat",
    h1: { fontSize: "1.625rem" },
    h2: { fontSize: "1.25rem", lineHeight: 1.5 },
    h3: { fontSize: "1.125rem" },
    h6: { fontSize: "1rem" },
    subtitle2: {
      lineHeight: 2,
      fontWeight: 700,
    },
    body1: {
      fontSize: ".875rem",
      lineHeight: 1.5,
    },
    body2: {
      fontSize: ".75rem",
      lineHeight: 1.5,
    },
  },
  overrides: {
    MuiStepIcon: {
      root: {
        color: "transparent",
        border: `1px solid ${defaultTheme.palette.common.white}`,
        borderRadius: "50%",
      },
      active: {
        color: "transparent !important",
      },
      completed: {
        color: `${defaultTheme.palette.common.white} !important`,
      },
    },
    MuiStepLabel: {
      label: {
        color: "transparent",
      },
      active: {
        color: `${defaultTheme.palette.common.white} !important`,
      },
      completed: {
        color: `${defaultTheme.palette.common.white} !important`,
      },
    },
    MuiStepConnector: {
      line: {
        borderColor: defaultTheme.palette.common.white,
      },
    },
    MuiStepContent: {
      root: {
        borderColor: defaultTheme.palette.common.white,
        color: `${defaultTheme.palette.common.white} !important`,
      },
    },
    MuiButton: {
      root: {
        fontWeight: 700,
        marginRight: defaultTheme.spacing(2),
      },
      contained: {
        padding: defaultTheme.spacing(1.25, 2),
      },
    },
    MuiOutlinedInput: {
      input: {
        padding: defaultTheme.spacing(2, 1.75),
      },
    },
  },
});

export default theme;
